"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iMarking = exports.iColor = exports.iHyperlinkMarking = exports.iTaskMarking = exports.iTextMarking = exports.iPathMarking = exports.iBoundsMarking = exports.iLatLngBounds = exports.iLatLng = void 0;
const t = require("io-ts");
const User = require("./user");
// MEME-LEVEL TYPE MASTURBATION FOR BRAINLETS
exports.iLatLng = t.interface({ lat: t.number, lng: t.number });
const _iLatLngBounds = t.interface({
    nw: exports.iLatLng,
    ne: exports.iLatLng,
    sw: exports.iLatLng,
    se: exports.iLatLng
});
exports.iLatLngBounds = t.clean(_iLatLngBounds);
const _iBoundsMarking = t.intersection([
    t.interface({
        type: t.union([t.literal('RECTANGLE'), t.literal('CLOUD'), t.literal('CIRCLE')]),
        bounds: exports.iLatLngBounds
    }),
    t.partial({
        reverseX: t.boolean,
        reverseY: t.boolean
    })
]);
exports.iBoundsMarking = t.clean(_iBoundsMarking);
const _iPathMarking = t.interface({
    type: t.literal('PATH'),
    path: t.array(exports.iLatLng)
});
exports.iPathMarking = t.clean(_iPathMarking);
const _iTextMarking = t.interface({
    type: t.literal('TEXT'),
    point: exports.iLatLng,
    text: t.string
});
exports.iTextMarking = t.clean(_iTextMarking);
const _iTaskMarking = t.interface({
    type: t.literal('TASK'),
    point: exports.iLatLng,
    text: t.string
});
exports.iTaskMarking = t.clean(_iTaskMarking);
const _iHyperlinkMarking = t.interface({
    type: t.literal('HYPERLINK'),
    point: exports.iLatLng,
    link: t.string
});
exports.iHyperlinkMarking = t.clean(_iHyperlinkMarking);
exports.iColor = t.partial({
    fill: t.string,
    stroke: t.string
});
const _iMarking = t.intersection([
    t.union([
        exports.iBoundsMarking,
        exports.iPathMarking,
        exports.iTextMarking,
        exports.iTaskMarking,
        exports.iHyperlinkMarking
    ]),
    t.union([
        t.interface({
            status: t.literal('PENDING')
        }),
        t.interface({
            status: t.literal('CREATED'),
            id: t.number,
            author: User.iAuthor,
            createdAt: t.string
        })
    ]),
    t.partial({
        color: exports.iColor
    })
]);
exports.iMarking = t.clean(_iMarking);
//# sourceMappingURL=marking.js.map